import { BrandConfigs } from "./brand-config"

export const lfConfigs: BrandConfigs = {
  dev: {
    favicon: "src/assets/images/lf-favicon-512x512.png",
    checkoutUrl: "checkout.letterfolk.com",
    siteUrl: "https://www.letterfolk.com",
    siteName: "Letterfolk",
    showGlobalNavigationBar: true,
    shopify: {
      id: "lf",
      name: "letterfolk",
      domain: "checkout.letterfolk.com",
      adminDomain: "letterfolk.myshopify.com",
      token: "20ad1ba627288ae1b93e43213a5f2335",
    },
    vendor: {
      segment: { key: "6FwOsuH6LkFWRg3oAxo9epuhm8o7tavg" },
      yotpo: {
        key: "eVdd7LysvivIL3j9VLOpZsf8RBexi7XVXvYbKUuu",
        url: "https://api.yotpo.com/v1/widget/reviews",
        appendDefaultObject: true,
      },
      auth0: {
        domain: "accounts-staging.patternbrands.co",
        clientId: "KgIwe3gEHCkd1KI9epdfHnNlG6beprF9",
      },
      klaviyo: {
        apiKey: "HcKvHJ",
      },
    },
    defaultPrimaryVariantType: "size",
  },
  production: {
    favicon: "src/assets/images/lf-favicon-512x512.png",
    checkoutUrl: "checkout.letterfolk.com",
    siteUrl: "https://www.letterfolk.com",
    siteName: "Letterfolk",
    showGlobalNavigationBar: true,
    shopify: {
      id: "lf",
      name: "letterfolk",
      domain: "checkout.letterfolk.com",
      adminDomain: "letterfolk.myshopify.com",
      token: "20ad1ba627288ae1b93e43213a5f2335",
    },
    vendor: {
      segment: { key: "6FwOsuH6LkFWRg3oAxo9epuhm8o7tavg" },
      commissionJunction: {
        enterpriseId: "1564188",
        scriptId: "261707006459",
      },
      yotpo: {
        key: "eVdd7LysvivIL3j9VLOpZsf8RBexi7XVXvYbKUuu",
        url: "https://api.yotpo.com/v1/widget/reviews",
        appendDefaultObject: true,
      },
      auth0: {
        domain: "account.patternbrands.com",
        clientId: "UrYCJer4VWvxt4JRWZbHRVsDUck1QVOC",
      },
      klaviyo: {
        apiKey: "HcKvHJ",
      },
    },
    defaultPrimaryVariantType: "size",
  },
}
